import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import EmerImg from "../../Ui/emergency-departmentImg.jpg";
import AnasImg from "../../Ui/anesImg.jpeg";
import CardioImg from "../../Ui/cardioImg.jpg";
import BioImg from "../../Ui/clinical-biochemistry-department.jpg";
import DermaImg from "../../Ui/dermaImg.jpg";
import HeamaImg from "../../Ui/heamaImg.jpg";
import Styledepartments from "./departments.module.css";
import DepartmentsBg from "../../Ui/departmentCover.jpg";
import DepartmentsBg1 from "../../Ui/departmentCover1.jpg";

import Cover from "../cover";
import { IoIosArrowDown } from "react-icons/io";
import Homecover2 from "../../Ui/sliderImg5.jpg";


const Departments = () => {
  const dep = [
    {
      id: 1,
      image: `${EmerImg}`,
      name: "Emergency Department",
      desp: "Handles urgent and life-threatening conditions, providing immediate diagnosis and treatment 24/7.",
    },
    {
      id: 2,
      image: `${AnasImg}`,
      name: "General Surgery",
      desp: "Performs surgical procedures involving various parts of the body such as the abdomen, skin, and soft tissues.",
    },
    {
      id: 3,
      image: `${CardioImg}`,
      name: "Cardiology",
      desp: "Focuses on diagnosis and treatment of heart-related diseases including hypertension, heart failure, and arrhythmias.",
    },
    {
      id: 4,
      image: `${BioImg}`,
      name: "Radiology",
      desp: "Uses imaging technologies like X-rays, MRI, and CT scans to diagnose and monitor internal diseases and injuries.",
    },
    {
      id: 5,
      image: `${DermaImg}`,
      name: "Pediatrics",
      desp: "Provides medical care for infants, children, and adolescents, focusing on growth, development, and disease treatment.",
    },
    {
      id: 6,
      image: `${HeamaImg}`,
      name: "Obstetrics & Gynecology",
      desp: "Deals with pregnancy, childbirth, and disorders of the female reproductive system.",
    },
  ];

  return (
    <>
      <Cover
        images={[DepartmentsBg, DepartmentsBg1, Homecover2]}
        heading="Welcome to our Department Page"
        subHeading="Extraordinary Care Is Right Here.."
      />
      <div className={Styledepartments.maincontainer}>
        <motion.div
          className={Styledepartments.toptext}
          initial={{ y: -100 }}
          animate={{ y: [200, 0] }}
          transition={{ duration: "1", delay: "1" }}
          whileInView="visible"
        >
          <h1>Departments</h1>
          <p>
            Great doctor if you need your family member to get immediate
            assistance, emergency treatment or a simple consultation.
          </p>
        </motion.div>

        <motion.div
        className={Styledepartments.arrowdown}
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1 }}
        >
          <IoIosArrowDown size={40} color="#333" />
        </motion.div>

        <div className={Styledepartments.container}>
          {dep.map((i) => (
            <motion.div
              className={Styledepartments.cards}
              initial={{ opacity: 0, scale: 0.8, y: 50 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              whileHover={{ scale: 1.05 }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                type: "spring",

                delay: i.id * 0.1, // slight stagger if looping
              }}
            >
              <Card sx={{ maxWidth: 350, borderRadius: 3, boxShadow: 4 }}>
                <div className={Styledepartments.media}>
                  <CardMedia
                    sx={{ height: 200 }}
                    image={i.image}
                    title="Doctors"
                    style={{ objectFit: "cover", marginBottom: "0" }}
                  />
                </div>

                <div className={Styledepartments.cardtext}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {i.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {i.desp}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button variant="outlined" href="#outlined-buttons">
                      View More
                    </Button>
                  </CardActions>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Departments;
